import React, { useState, useEffect, Fragment } from "react";
import { Card, CardHeader, Col, Table, Input, Media, Label } from "reactstrap";
import { FormLabel } from 'react-bootstrap';
import { Filter, X, Eye } from "react-feather";
import Skeleton from "react-loading-skeleton";
// import { listSalesAPI } from "../../api/sales"; // your sales history API
// import { decryptResponseData } from "../../utils/crypto";
// import errorImage from "../../assets/images/error-image.png";
// import { imageBaseURL } from "../../config";
import { Breadcrumbs, ToolTip } from "../../AbstractElements";
import MyPagination from "../pagination";
import SalesDetailsModal from "./SalesDetailsModal";
import { useTranslation } from "react-i18next";
import { useLoader } from "../../_helper/LoaderContext";
import { salesList } from "./SalesService";
import { useNavigate } from "react-router-dom";
import { usePharmacy } from "../../_helper/PharmacyProvider";
import { useAtom } from "jotai";
import { SaleHistoryPageAtom, SaleHistoryPageSizeAtom } from "./SalesAtoms";
import { useCurrency } from "../../_helper/CurrencyContext";

export const salesHistoryData = [
	{
		invoiceNumber: "INV-1001",
		productName: "Paracetamol 500mg Tablet",
		manufacturer: "Cipla Ltd.",
		saltName: "Paracetamol",
		quantity: 20,
		productType: "Tablet",
		amount: 150.0,
		currency: "INR",
		paymentMethod: "Cash",
		date: "2025-08-01",
		note: "Urgent delivery",
		tax: 9.0,
		transportCharge: 20.0,
		discountType: "percentage",
		discount: 5
	},
	{
		invoiceNumber: "INV-1002",
		productName: "Amoxicillin 250mg Capsule",
		manufacturer: "Sun Pharma",
		saltName: "Amoxicillin",
		quantity: 10,
		productType: "Capsule",
		amount: 350.0,
		currency: "INR",
		paymentMethod: "UPI",
		date: "2025-08-02",
		note: "",
		tax: 15.0,
		transportCharge: 0,
		discountType: "fixed",
		discount: 20
	},
	{
		invoiceNumber: "INV-1003",
		productName: "Cetirizine 10mg Tablet",
		manufacturer: "Dr. Reddy's",
		saltName: "Cetirizine Hydrochloride",
		quantity: 15,
		productType: "Tablet",
		amount: 120.0,
		currency: "INR",
		paymentMethod: "Credit Card",
		date: "2025-08-05",
		note: "Allergic reaction meds",
		tax: 5.0,
		transportCharge: 10.0,
		discountType: "percentage",
		discount: 10
	},
	{
		invoiceNumber: "INV-1004",
		productName: "Vitamin C Chewable Tablet",
		manufacturer: "Glenmark",
		saltName: "Ascorbic Acid",
		quantity: 25,
		productType: "Tablet",
		amount: 250.0,
		currency: "INR",
		paymentMethod: "Cash",
		date: "2025-08-07",
		note: "",
		tax: 12.0,
		transportCharge: 15.0,
		discountType: "fixed",
		discount: 30
	}
];

export const salesDetailsData = {
	invoiceNumber: "INV-1001",
	customerName: "Rahul Sharma",
	customerContact: "+91-9876543210",
	date: "2025-08-01",
	paymentMethod: "Cash",
	currency: "INR",
	note: "Urgent delivery",
	transportCharge: 20.0,
	tax: 9.0,
	discountType: "percentage",
	discount: 5,
	items: [
		{
			productName: "Paracetamol 500mg Tablet",
			manufacturer: "Cipla Ltd.",
			saltName: "Paracetamol",
			productType: "Tablet",
			quantity: 10,
			price: 7.5,
			total: 75.0
		},
		{
			productName: "Ibuprofen 400mg Tablet",
			manufacturer: "Sun Pharma",
			saltName: "Ibuprofen",
			productType: "Tablet",
			quantity: 10,
			price: 7.5,
			total: 75.0
		}
	],
	grandTotal: 150.0
};

const SalesHistory = () => {
	const { getCurrencySymbol } = useCurrency();

	// const [salesData, setSalesData] = useState([]);
	const [salesData, setSalesData] = useState([]);
	const [page, setPage] = useAtom(SaleHistoryPageAtom);
	const [size, setSize] = useAtom(SaleHistoryPageSizeAtom);
	const [totalItems, setTotalItems] = useState(0);
	const [searchValue, setSearchValue] = useState("");
	const { setLoading } = useLoader();
	const [skeletonLoading, setSkeletonLoading] = useState(false);
	const [filterTooltipOpen, setFilterTooltipOpen] = useState(false);
	const [clearTooltipOpen, setClearTooltipOpen] = useState(false);
	const [isClearing, setIsClearing] = useState(false);
	// const [selectedSale, setSelectedSale] = useState(null);
	const [selectedSale, setSelectedSale] = useState(salesDetailsData);
	const [detailsModalOpen, setDetailsModalOpen] = useState(false);
	const { t } = useTranslation();
	const history = useNavigate();
	const { pharmacyPOS } = usePharmacy();

	// Tooltips
	const [editTooltipOpen, setEditTooltipOpen] = useState(false);
	const [viewTooltipOpen, setViewTooltipOpen] = useState(false);
	const [deleteTooltipOpen, setDeleteTooltipOpen] = useState(false);
	const toggleEditTooltip = () => setEditTooltipOpen(!editTooltipOpen);
	const toggleViewTooltip = () => setViewTooltipOpen(!viewTooltipOpen);
	const toggleDeleteTooltip = () => setDeleteTooltipOpen(!deleteTooltipOpen);

	useEffect(() => {
		getSalesList();
	}, [page, size]);

	const getSalesList = async () => {
		const body = {
			clinicId: pharmacyPOS?.hospital_id,
			page: page,
			limit: size,
			search: searchValue.trim()
		};
		try {
			setLoading(true);
			setSkeletonLoading(true);
			const response = await salesList(body);
			// const dec_data = decryptResponseData(response);
			// if (dec_data) {
			setSalesData(response.data.data.sales || []);
			const totalCount = response.data.data.total || 0;
			setTotalItems(Math.ceil(totalCount / size));
			// }
		} catch (error) {
			console.error("Error fetching sales history:", error);
		} finally {
			setLoading(false);
			setSkeletonLoading(false);
		}
	};

	const handleSearchButtonClick = () => {
		if (searchValue.trim() !== "") {
			setPage(1);
			getSalesList();
		}
	};

	const handleClear = () => {
		setIsClearing(true);
		setSearchValue("");
	};

	useEffect(() => {
		if (isClearing) {
			getSalesList();
			setIsClearing(false);
		}
	}, [isClearing]);

	const handlePageChange = (pageNumber) => setPage(pageNumber);

	const handlePageSizeChange = (e) => {
		setSize(parseFloat(e.target.value));
		setPage(1);
	};

	const toggleFilterTooltip = () => setFilterTooltipOpen(!filterTooltipOpen);
	const toggleClearTooltip = () => setClearTooltipOpen(!clearTooltipOpen);

	const openDetailsModal = (sale) => {
		setSelectedSale(sale);
		setDetailsModalOpen(true);
	};

	const handleEditClick = (id) => {
		history(`${process.env.PUBLIC_URL}/update-sale/${id}`);
	};

	const handleViewClick = (id) => {
		history(`${process.env.PUBLIC_URL}/view-sale/${id}`);
	};

	const handleDeleteClick = (id) => {
		// const updated = stockData.filter((s) => s.id !== id);
		// setStockData(updated);
		// setTotalItems(updated.length);
	};

	const formatDate = (dateString) => {
		if (!dateString) return "N/A";
		const date = new Date(dateString);
		const day = date.getDate().toString().padStart(2, '0');
		const month = date.toLocaleString(undefined, { month: 'short' });
		const year = date.getFullYear();
		return `${day} ${month} ${year}`; // Example: May 07, 2025
	};

	const formatAmount = (val) => (Number(val) || 0).toFixed(2);

	const getStatusBadge = (sale) => {
		if (sale.isSettled) {
			return <span className="badge bg-success">{t("Settled")}</span>;
		}
		if (sale.isPaid) {
			return <span className="badge bg-primary">{t("Paid")}</span>;
		}
		if (sale.isPartialPaid) {
			return <span className="badge bg-warning">{t("Partial")}</span>;
		}
		if (sale.USDBalance > 0) {
			return <span className="badge bg-danger">{t("Pending")}</span>;
		}
		if (sale.salesType === "return") {
			return <span className="badge bg-danger">{t("Return")}</span>;
		}
		return null;
	};

	return (
		<Fragment>
			<Breadcrumbs mainTitle={t("Sales History")} parent={t("Dashboard")} title={t("Sales History")} />
			<Col sm="12">
				<Card>
					{/* <CardHeader className="d-flex justify-content-between align-items-center">
						<h5>{t("Sales History")}</h5>
					</CardHeader> */}

					{/* Search & Filter */}
					<div className="row" style={{ alignItems: "center", padding: "12px 24px" }}>
						<Col sm="8" lg="8" xl="10" md="8">
							<Input
								type="text"
								placeholder={t("Search by Invoice No, Customer Name")}
								value={searchValue}
								onChange={(e) => setSearchValue(e.target.value)}
								onKeyDown={(e) => {
									if (e.key === "Enter") handleSearchButtonClick();
								}}
							/>
						</Col>
						<Col className="col-xl-2 col-lg-4 col-md-4 col-sm-4 d-flex justify-content-start align-items-center" style={{ gap: '18px' }}>
							<button id='FilterToolTip' className='btn btn-primary' style={{ height: "40px" }} onClick={handleSearchButtonClick}>
								<Filter />
							</button>
							<ToolTip
								attrToolTip={{
									placement: 'top',
									isOpen: filterTooltipOpen,
									target: 'FilterToolTip',
									toggle: toggleFilterTooltip
								}}
							>
								<strong>{t("Filter")}</strong>
							</ToolTip>
							<button id='ClearToolTip' className='btn btn-secondary' style={{ height: "40px" }} onClick={handleClear}>
								<X />
							</button>
							<ToolTip
								attrToolTip={{
									placement: 'top',
									isOpen: clearTooltipOpen,
									target: 'ClearToolTip',
									toggle: toggleClearTooltip
								}}
							>
								<strong>{t("Clear")}</strong>
							</ToolTip>
						</Col>
					</div>
				</Card>
				<Card>
					{/* Table */}
					<div className="card-block">
						<div className="row" style={{ padding: "12px 24px" }}>
							<Col sm="12">
								<div className="rounded table-responsive">
									<Table className='mb-0 table-center table-bordered table-hover'>
										<thead>
											<tr>
												<th>#</th>
												<th>{t("Sales Number")}</th>
												<th>{t("Sales Type")}</th>
												<th>{t("Selling Date")}</th>
												<th>{t("Patient Name")}</th>
												<th>{t("Grand Total")}</th>
												<th>{t("Paid Amount")}</th>
												<th>{t("Outstanding Balance")}</th>
												<th>{t("Status")}</th>
												<th className="text-center">{t("Action")}</th>
											</tr>
										</thead>
										<tbody>
											{skeletonLoading ? (
												[...Array(5)].map((_, i) => (
													<tr key={i}>
														{Array(10).fill().map((_, idx) => (
															<td key={idx}><Skeleton height={20} /></td>
														))}
													</tr>
												))
											) : salesData.length > 0 ? (
												salesData.map((sale, index) => (
													<tr key={index}>
														<td>{(page - 1) * size + index + 1}</td>
														<td>{sale.salesNumber}
															{sale.isReturn &&
																<span className="badge bg-danger ms-2">
																	{t("Returned")}
																</span>
															}
														</td>
														<td className="text-uppercase">
															{sale.salesType === "return" ? (
																<span className="badge bg-danger">
																	{sale.salesType}
																</span>
															) : (
																<span className="badge bg-success">{sale.salesType}</span>
															)}
														</td>
														<td>{formatDate(sale.createdAt)}</td>
														<td>{sale.patientName}</td>
														{/* <td>${sale.netTotal.toFixed(2)} ({sale.otherNetTotalPrice.toFixed(2)} ZiG)</td> */}
														<td>
															<strong>
																{getCurrencySymbol(sale.currencyType)}{formatAmount(sale.netTotal)}
															</strong>
															{/* <br />
															<small className="text-muted">
																{sale.otherNetTotalPrice.toFixed(2) || "0.00"} ZiG
															</small> */}
														</td>
														<td className="fw-bold">{getCurrencySymbol(sale.currencyType)}{formatAmount(sale.totalPaid)}</td>
														<td className={sale.dueAmount > 0 ? "text-danger fw-bold" : ""}>{sale.dueAmount !== 0 ? `${getCurrencySymbol(sale.currencyType)}${formatAmount(sale.dueAmount)}` : `-`}</td>
														<td>{getStatusBadge(sale)}</td>
														<td className="text-center">
															<button
																className="success-action-button me-1"
																id="ViewToolTip"
																// onClick={() => openDetailsModal(sale)}
																onClick={() => handleViewClick(sale?._id)}
															>
																<i
																	className="fa fa-eye"
																	style={{ fontSize: "18px" }}
																></i>
																<ToolTip
																	attrToolTip={{
																		placement: "top",
																		isOpen: viewTooltipOpen,
																		target: "ViewToolTip",
																		toggle: toggleViewTooltip,
																	}}
																>
																	<strong>{t("View")}</strong>
																</ToolTip>
															</button>
														</td>
													</tr>
												))
											) : (
												<tr className="text-center">
													<td colSpan="17">{t("No sales records available.")}</td>
												</tr>
											)}
										</tbody>
									</Table>
								</div>
							</Col>

							{/* Pagination */}
							<Col sm="12" className="mt-4">
								<div className="text-center d-md-flex align-items-center justify-content-between">
									<div className="pt-3 show-entries">
										<FormLabel>{t("Show")}&nbsp;</FormLabel>
										<select value={size} onChange={handlePageSizeChange} className="form-control" style={{ display: 'unset', width: 'auto' }}>
											<option value={5}>5</option>
											<option value={10}>10</option>
											<option value={20}>20</option>
											<option value={30}>30</option>
											<option value={50}>50</option>
										</select>&nbsp;
										<FormLabel>{t("entries")}</FormLabel>
									</div>
									<MyPagination totalPages={totalItems} currentPage={page} onPageChange={handlePageChange} />
								</div>
							</Col>
						</div>
					</div>
				</Card>
			</Col>

			{/* Details Modal */}
			{selectedSale && (
				<SalesDetailsModal
					show={detailsModalOpen}
					handleClose={() => setDetailsModalOpen(false)}
					sale={selectedSale}
				/>
			)}
		</Fragment>
	);
};

export default SalesHistory;
